import React from "react";
import { SkeletonBase, SkeletonLine } from "@ui-components/Skeleton/GenericSkeleton";

/**
 * Skeleton component for cluster cards in High Availability page.
 * Simulates the structure of GroupsWidget component.
 */
export const ClusterCardSkeleton: React.FC = () => (
    <div className="bg-semantic-bg-primary border border-semantic-border-secondary rounded-sm shadow-sm p-4 space-y-3 w-full">
        {/* Header with title and buttons */}
        <div className="flex items-center justify-between">
            <SkeletonLine w="40%" h={20} />
            <div className="flex items-center gap-3">
                <SkeletonBase w={24} h={24} roundedClass="rounded" />
                <SkeletonBase w={24} h={24} roundedClass="rounded" />
            </div>
        </div>
        {/* Diagram area */}
        <div className="flex justify-center">
            <SkeletonBase
                w={260}
                h={100}
                roundedClass="rounded-sm"
                className="border border-semantic-border-secondary"
            />
        </div>
        {/* CTX names list */}
        <div className="flex justify-evenly text-sm">
            <div className="text-center">
                <SkeletonLine w={80} h={16} />
                <SkeletonLine w={60} h={12} className="mt-1" />
            </div>
            <div className="text-center">
                <SkeletonLine w={80} h={16} />
                <SkeletonLine w={60} h={12} className="mt-1" />
            </div>
        </div>
        {/* Table skeleton */}
        <div className="w-full border border-semantic-border-secondary text-sm">
            <div className="bg-semantic-bg-secondary p-2 border-b border-semantic-border-secondary">
                <div className="flex gap-2">
                    <SkeletonLine w="30%" h={16} />
                    <SkeletonLine w="30%" h={16} />
                    <SkeletonLine w="30%" h={16} />
                </div>
            </div>
            <div className="p-2 space-y-2">
                {[1, 2].map((i) => (
                    <div key={i} className="flex gap-2">
                        <SkeletonLine w="30%" h={16} />
                        <SkeletonLine w="30%" h={16} />
                        <SkeletonLine w="30%" h={16} />
                    </div>
                ))}
            </div>
        </div>
        {/* Overall status text */}
        <SkeletonLine w="90%" h={12} />
    </div>
);

